import { Option } from "../../../../components/DropDown/props";

export const priority: Option[] = [
  { id: "low", name: "low" },
  { id: "high", name: "high" },
  { id: "urgent", name: "urgent" },
];
export const status: Option[] = [
  { id: "todo", name: "todo" },
  { id: "in progress", name: "in progress" },
  { id: "query", name: "query" },
  { id: "finished", name: "finished" },
];
